import {gql} from '@apollo/client'

export default gql`
mutation AddProblemToSurvey($surveyId:ID!,$page_number:Int,$problem_type:String,$content:String) {
  addProblemToSurvey(surveyId:$surveyId,page_number:$page_number,problem_type:$problem_type,content:$content) {
    id
  }
}
`